export default "__VITE_ASSET__BSQL3KKH__"